import React, { useState, useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Dialog } from "primereact/dialog";
import CustomButton, {
  OutlineCustomButton,
} from "shared/components/inputButton";
import { getProfileAction } from "store/actions/UserActions";
import { useDispatch, useSelector } from "react-redux";

const SignatureModal = ({
  visible,
  setVisible,
  typedSignature,
  setTypedSignature,
  drawnSignature,
  setDrawnSignature,
  onSave,
  currentSigner,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const signatureCanvasRef = useRef(null);
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.user);

  useEffect(() => {
    if (!profile?._id) {
      dispatch(getProfileAction(dispatch));
    }
  }, [profile, dispatch]);

  const handleClearSignature = () => {
    if (signatureCanvasRef.current) {
      signatureCanvasRef.current.clear();
      setDrawnSignature(false);
    }
  };

  const handleSave = () => {
    const role = currentSigner;
    let signatureData = null;

    if (activeIndex === 0 && typedSignature) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = 100;
      canvas.height = 25;

      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = "bold 24px Arial";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(typedSignature, canvas.width / 2, canvas.height / 2);

      const signatureImage = canvas.toDataURL("image/png");

      signatureData = {
        role,
        type: "typed",
        signature: signatureImage,
      };
      onSave(signatureData);
    } else if (
      activeIndex === 1 &&
      signatureCanvasRef.current &&
      !signatureCanvasRef.current.isEmpty()
    ) {
      signatureData = {
        role,
        type: "drawn",
        signature: signatureCanvasRef.current.toDataURL(),
        typedSignature: typedSignature || null,
      };
      onSave(signatureData);
      setDrawnSignature(true);
    } else {
      console.warn("Validation failed:", {
        hasTypedSignature: !!typedSignature,
        hasValidCanvas: !!signatureCanvasRef.current,
        isCanvasEmpty: signatureCanvasRef.current?.isEmpty(),
      });
    }

    setVisible(false);
  };

  const handleCanvasEnd = () => {
    if (!signatureCanvasRef.current.isEmpty()) {
      setDrawnSignature(true);
    }
  };

  return (
    <Dialog
      header="Sign Document"
      visible={visible}
      onHide={() => {
        setVisible(false);
        setTypedSignature("");
      }}
      style={{ width: "60vw" }}
      breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      draggable={false}
      resizable={false}
    >
      <p className="m-0 text-black-alpha-90">Add Signature</p>
      <div className="my-3 signature-tab flex">
        <p
          onClick={() => setActiveIndex(0)}
          className={`w-6 text-center p-2 ${activeIndex === 0 ? "active" : ""}`}
        >
          Type Signature
        </p>
        <p
          onClick={() => setActiveIndex(1)}
          className={`w-6 text-center p-2 ${activeIndex === 1 ? "active" : ""}`}
        >
          Draw Signature
        </p>
      </div>
      <div className="border-1 mb-3 border-400 border-round-lg p-3">
        <small className="text-black-alpha-90">Name of the Signee</small>
        <h5 className="text-lg">{profile?.fullName}</h5>
      </div>
      {activeIndex === 0 ? (
        <div className="flex mb-2 align-items-center justify-content-center lightest-green border-round-lg p-3">
          <input
            type="text"
            placeholder="Type your signature"
            value={typedSignature}
            onChange={(e) => {
              const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              setTypedSignature(filteredValue);
            }}
            className="w-full p-3 border-round-lg border-1"
          />
        </div>
      ) : (
        <div className=" mb-2 flex flex-column justify-content-start align-items-start gap-4 lightest-green border-round-lg p-3">
          <SignatureCanvas
            ref={signatureCanvasRef}
            onEnd={handleCanvasEnd}
            className="w-full"
            canvasProps={{
              width: 700,
              height: 200,
              className: "sigCanvas border-round-lg",
              style: {
                backgroundColor: "white",
              },
            }}
          />
          <OutlineCustomButton
            label="Clear"
            extraClassName="border-round-lg"
            onClick={handleClearSignature}
            className="p-button-text"
          />
        </div>
      )}
      <p className="text-black-alpha-90">
        I agree for my signature above to be a valid means of signing.
      </p>
      <div className="flex gap-3 justify-content-end mt-4">
        <OutlineCustomButton
          label="Cancel"
          extraClassName="border-round-lg"
          onClick={() => {
            setVisible(false);
            setTypedSignature("");
          }}
          className="p-button-text"
        />
        <CustomButton
          label="Save"
          extraClass="w-auto border-round-3xl"
          onClick={handleSave}
          autoFocus
        />
      </div>
    </Dialog>
  );
};

export default SignatureModal;
